import Swal from 'sweetalert2';

export const block = () => {
    Swal.fire({
        title: '',
        text: 'Por favor espere',
        allowOutsideClick: false,
        didOpen: () =>{
            Swal.showLoading();
        }
    });
};

export const unblock = () => {
    Swal.close();
};